import React, { useCallback, useState } from 'react'
import { TextAreaError, TextAreaField, TextAreaLabel, TextAreaLabelText, TextAreaWrapper } from '../index.styled'

const TextAreaInputControlled = React.memo(({
	name,
	label = '',
	type = 'text',
	defaultValue,
	readOnly,
	value,
	autoFocus,
	testId,
	tabIndex,
	color,
	autoComplete,
	disabled,
	size,
	className,
	errorMessage,
	isIcon = false,
	hasLongError = false,
	hasLongTextError = false,
	onChange,
	onBlur = () => {
	},
	onFocus = () => {
	},
	placeholder,
	refInput = null,
}) => {

	const [focused, setFocused] = useState(false)
	const errorClass = (hasLongError ? 'error-big' : 'error') + (hasLongTextError ? ' error-big-text' : '')

	const handleFocus = useCallback(() => {
		setFocused(true)
		onFocus()
	}, [onFocus])

	const handleBlur = () => {
		setFocused(false)
		onBlur()
	}

	const labelUp = focused || readOnly || defaultValue || (value || value === 0)
	const layout = (focused ? 'focus ' : '') + (errorMessage ? `${errorClass} ` : '') + (labelUp ? '' : 'toggled ') + (disabled ? 'disabled ' : '') + (color ? color + ' ' : '')  + size + ' ' + className

	let typeInput = ''
	if (type) {
		typeInput = type
	}

	return (
		<TextAreaWrapper className={layout}>
			{errorMessage && <TextAreaError type={type} className={layout}>{errorMessage}</TextAreaError>}
			<TextAreaLabel className={layout}>
				<TextAreaLabelText className={layout}>{label}</TextAreaLabelText>
				<TextAreaField data-testid={testId ?? null}
											 id={name}
											 name={name}
											 rows="10"
											 ref={refInput}
											 value={value}
											 type={typeInput}
											 autoFocus={autoFocus}
											 autoComplete={autoComplete || 'off'}
											 role="presentation"
											 onFocus={handleFocus}
											 className={layout}
											 readOnly={readOnly}
											 onBlur={handleBlur}
											 tabIndex={tabIndex}
											 disabled={disabled}
											 onChange={onChange}
											 placeholder={placeholder} />
			</TextAreaLabel>
		</TextAreaWrapper>
	)
})

TextAreaInputControlled.displayName = 'TextAreaInputControlled'
export default TextAreaInputControlled
